import {useCoordinationRole, useGameServerConnection} from '@glark-newco/game-library';
import _ from 'lodash';
import {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {CrunchTimeEvent, SignlinesPayload} from '../SignlinesPayloadTypes';
import {useCrunchTimeStartTime} from '../state/signlinesTimestampsSlice';

const lastTileDelay = 29 * 350; // ms
const revealTileDuration = 750; // ms
export const crunchTimeTransitionDuration = lastTileDelay + revealTileDuration;

export function useCrunchTime() {
    const {publishPlayerAction} = useGameServerConnection<SignlinesPayload>();
    const crunchTimeStartTime = useCrunchTimeStartTime();
    const {isCoordinator} = useCoordinationRole();

    // This may be configured by the Facilitator in the future.
    const crunchTimeDurationMs = 20000;

    const isCrunchTime = useMemo(() => {
        return !!crunchTimeStartTime;
    }, [crunchTimeStartTime]);

    const publishCrunchTimeEvent = useCallback(() => {
        if (!isCoordinator)
            return; // TODO - Add test for publishing by a non-facilitator coordinator
        publishPlayerAction({
            type: 'crunchTimeEvent',
        } as CrunchTimeEvent);
    }, [isCoordinator, publishPlayerAction]);

    // console.debug(`useCrunchTime crunchTimeStartTime: ${crunchTimeStartTime?.toISOString()}, isCrunchTime: ${isCrunchTime}`)
    return {isCrunchTime, publishCrunchTimeEvent, crunchTimeStartTime, crunchTimeDurationMs};
}

export function useCrunchTimeTransition(delay: number = 0): boolean {
    const crunchTimeStartTime = useCrunchTimeStartTime();
    const initialCrunchTimeState = useRef(crunchTimeStartTime);
    const [playAnimation, setPlayAnimation] = useState<boolean>(false);

    useEffect(() => {
        setTimeout(()=> {
            setPlayAnimation(!_.isEqual(crunchTimeStartTime, initialCrunchTimeState.current));
        }, delay);
    }, [crunchTimeStartTime]);

    return playAnimation;
}
